import { combineReducers } from 'redux';
import active from '../screens/Active/reducers';
import end from '../screens/End/reducers';
import index from '../screens/Index/reducers';
import store from '../screens/Store/reducers';
export default combineReducers({
  active,
  end,
  index,
  store,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Orders/reducers/index.js
 **/